import React from 'react';
import { View, Text, StyleSheet } from '@react-pdf/renderer';
import { PDF_COLORS } from '../pdfColors';
import { MAX_GRID_IMAGES, type ReportImage } from '../reportImages';
import { PhotoCell } from './PhotoCell';

const styles = StyleSheet.create({
  grid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginTop: 6,
    gap: 6,
  },
  cell: {
    width: '31.5%',
    marginBottom: 4,
    padding: 3,
    borderWidth: 0.5,
    borderColor: PDF_COLORS.greyMid,
    borderRadius: 3,
    backgroundColor: PDF_COLORS.greyLight,
  },
  image: {
    width: '100%',
    height: 66,
    borderRadius: 2,
    objectFit: 'cover',
  },
  caption: {
    fontSize: 6.5,
    fontFamily: 'Poppins',
    color: PDF_COLORS.greyDark,
    marginTop: 3,
    textAlign: 'center',
  },
  moreText: {
    fontSize: 7,
    fontFamily: 'Poppins',
    fontWeight: 600,
    color: PDF_COLORS.greyDark,
    marginTop: 5,
    textAlign: 'center',
  },
});

interface ImageGridProps {
  images: ReportImage[];
}

const MAX_IMAGES = MAX_GRID_IMAGES;

export const ImageGrid = ({ images }: ImageGridProps) => {
  const displayed = images.slice(0, MAX_IMAGES);
  const remaining = images.length - displayed.length;

  return (
    <View>
      <View style={styles.grid}>
        {displayed.map((img, i) => (
          <PhotoCell
            key={i}
            url={img.url}
            name={img.name}
            location={img.location}
            cellStyle={styles.cell}
            imageStyle={styles.image}
            captionStyle={styles.caption}
          />
        ))}
      </View>
      {remaining > 0 && (
        <Text style={styles.moreText}>
          ... i {remaining} imatge{remaining > 1 ? 's' : ''} més
        </Text>
      )}
    </View>
  );
};
